
import { getPropertyByKey } from '../../helper/utils/getPropertyByKey';
import { getGrandTotal, getGrandTotalBeforeRounded, getGrandTotalWithoutTaxRounded } from './menuItem';

export function isRounded() {
    return getPropertyByKey('XRounded') == true; //* Ambil dari proeprty
}

export function getRounded(items = [], salesOrderData = {}) {
    if (isRounded()) {
        if (items.length > 0) {
            const grandTotalBeforeRounded = getGrandTotalBeforeRounded(items, salesOrderData);
            const getValRounded = Math.ceil(grandTotalBeforeRounded / 500) * 500;

            return getValRounded - grandTotalBeforeRounded;
        }
    } else {
        const grandTotalBeforeRounded = getGrandTotal(items, salesOrderData);
        const decimalPart = grandTotalBeforeRounded - Math.floor(grandTotalBeforeRounded);

        if (decimalPart >= 0.5) {
            return Math.ceil(grandTotalBeforeRounded) - grandTotalBeforeRounded;
        } else {
            return Math.floor(grandTotalBeforeRounded) - grandTotalBeforeRounded;
        }
    }

    return 0.0;
}

export function manualRounded(number = 0) {
    const integerPart = Math.floor(number);
    const decimalPart = number - integerPart;

    if (decimalPart < 0.5) {
        return parseInt(number);
    } else {
        return integerPart + 1;
    }
}

export function getRoundedWithoutTax(items = [], salesOrderData = {}) {
    if (isRounded()) {
        if (items.length > 0) {
            const grandTotalBeforeRounded = getGrandTotalWithoutTaxRounded(items, salesOrderData);
            const getValRounded = Math.ceil(grandTotalBeforeRounded / 500) * 500;

            return getValRounded - grandTotalBeforeRounded;
        }
    }

    return 0.0;
}
